module.exports = __webpack_public_path__ + "img/alentour19.7a97aa72.jpg";